import template from './layout.jade';
import layoutItems from '../../../enums/layout';

export default angular
    .module('cian.addForm.layout', ['cian.addForm.fieldTypeSwitcher'])
    .directive('cianAfAboutObjectLayout', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller() {
            this.items = layoutItems;
        },
        controllerAs: 'layout',
        template,
    }))
    .name;
